// https://vuex.vuejs.org/en/state.html

export default {
	user: {
      loggedIn: false,
      data: null
    },
    vid:'',
    vendors:[]
  //
}
